export default __webpack_public_path__ + "static/media/after@3x.dafb4483.png";